import { message } from "antd";
import AccessRequests from "app/api/access";
import { handleGenericApiError } from "app/api/error";
import { I18n } from "react-redux-i18n";
import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_ACCESS_CONSOLIDATED =
  "access:ACTION_SAVE_ACCESS_CONSOLIDATED";
export const ACTION_SAVE_TOTAL_ACCESS_CONSOLIDATED =
  "access:ACTION_SAVE_TOTAL_ACCESS_CONSOLIDATED";
export const ACTION_SAVE_TOTAL_HASH_AGENCY =
  "access:ACTION_SAVE_TOTAL_HASH_AGENCY";

export const fetchAccessConsolidated = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await AccessRequests.fetchAccessConsolidated(params);
    dispatch({ type: ACTION_SAVE_ACCESS_CONSOLIDATED, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchTotalAccessConsolidated = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await AccessRequests.fetchTotalAccessConsolidated(params);
    dispatch({ type: ACTION_SAVE_TOTAL_ACCESS_CONSOLIDATED, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadAccessPerClientConsolidated = params => async () => {
  if (params.searchParameter?.InitialDate && params.searchParameter?.EndDate) {
    var initialDate = params.searchParameter?.InitialDate.split(" ");
    var endDate = params.searchParameter?.EndDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response =
          await AccessRequests.downloadAccessPerClientConsolidated(
            params.searchParameter
          );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "consolidados_accessos.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const downloadTotalAccessConsolidated = params => async () => {
  if (params.searchParameter?.InitialDate && params.searchParameter?.EndDate) {
    var initialDate = params.searchParameter?.InitialDate.split(" ");
    var endDate = params.searchParameter?.EndDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await AccessRequests.downloadTotalAccessConsolidated(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "consolidados_total_acessos.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};
